import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useState } from 'react';
import { HOME_URL } from "../constants";
import { useCentralizedCorporateGetChildrenOrgsNavigationQueryQuery } from "./graphql/corporate-get-children-org-navigation-query.v5.generated";
export var useCorporateOrganizations = function useCorporateOrganizations(_ref) {
  var _data$corporation, _data$corporation$nav;
  var slug = _ref.slug,
    search = _ref.search,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 8 : _ref$pageSize,
    skip = _ref.skip;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fetchingMore = _useState2[0],
    setFetchingMore = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    cachedCorporationData = _useState4[0],
    setCachedCorporationData = _useState4[1];
  var _useCentralizedCorpor = useCentralizedCorporateGetChildrenOrgsNavigationQueryQuery({
      variables: {
        input: {
          slug: slug,
          pagination: {
            after: null,
            first: pageSize
          },
          search: {
            search: search
          }
        }
      },
      context: {
        clientName: 'v5'
      },
      skip: skip,
      notifyOnNetworkStatusChange: true
    }),
    data = _useCentralizedCorpor.data,
    error = _useCentralizedCorpor.error,
    refetch = _useCentralizedCorpor.refetch,
    fetchMore = _useCentralizedCorpor.fetchMore,
    loading = _useCentralizedCorpor.loading;
  var result = data === null || data === void 0 ? void 0 : (_data$corporation = data.corporation) === null || _data$corporation === void 0 ? void 0 : (_data$corporation$nav = _data$corporation.navigation_data) === null || _data$corporation$nav === void 0 ? void 0 : _data$corporation$nav.navigation_data;
  var organizations = useMemo(function () {
    return (result === null || result === void 0 ? void 0 : result.__typename) === 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' ? result.organizations.map(function (org) {
      return {
        id: org.id,
        name: org.name,
        slug: org.slug,
        homeUrl: HOME_URL.replace('[slug]', org.slug)
      };
    }) : [];
  }, [result]);
  var handleFetchMore = function handleFetchMore() {
    var _data$corporation2, _data$corporation2$na, _data$corporation2$na2, _data$corporation3, _data$corporation3$na, _data$corporation3$na2, _data$corporation4, _data$corporation4$na, _data$corporation4$na2;
    // Prevent concurrent fetches
    if (fetchingMore) {
      return;
    }
    if ((data === null || data === void 0 ? void 0 : (_data$corporation2 = data.corporation) === null || _data$corporation2 === void 0 ? void 0 : (_data$corporation2$na = _data$corporation2.navigation_data) === null || _data$corporation2$na === void 0 ? void 0 : (_data$corporation2$na2 = _data$corporation2$na.navigation_data) === null || _data$corporation2$na2 === void 0 ? void 0 : _data$corporation2$na2.__typename) !== 'HRISCorporationsGetChildrenOrgNavigationQueryPayload') {
      return;
    }
    if (!(data !== null && data !== void 0 && (_data$corporation3 = data.corporation) !== null && _data$corporation3 !== void 0 && (_data$corporation3$na = _data$corporation3.navigation_data) !== null && _data$corporation3$na !== void 0 && (_data$corporation3$na2 = _data$corporation3$na.navigation_data) !== null && _data$corporation3$na2 !== void 0 && _data$corporation3$na2.has_next_page)) {
      return;
    }
    setFetchingMore(true);
    return fetchMore({
      variables: {
        input: _objectSpread({
          slug: slug,
          pagination: {
            after: data === null || data === void 0 ? void 0 : (_data$corporation4 = data.corporation) === null || _data$corporation4 === void 0 ? void 0 : (_data$corporation4$na = _data$corporation4.navigation_data) === null || _data$corporation4$na === void 0 ? void 0 : (_data$corporation4$na2 = _data$corporation4$na.navigation_data) === null || _data$corporation4$na2 === void 0 ? void 0 : _data$corporation4$na2.end_cursor,
            first: pageSize
          }
        }, search && {
          search: {
            search: search
          }
        })
      },
      updateQuery: function updateQuery(prev, _ref2) {
        var _fetchMoreResult$corp, _fetchMoreResult$corp2, _fetchMoreResult$corp3, _prev$corporation, _prev$corporation$nav, _fetchMoreResult$corp4, _fetchMoreResult$corp5, _data$corporation5, _data$corporation5$na, _prev$corporation2;
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult || (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$corp = fetchMoreResult.corporation) === null || _fetchMoreResult$corp === void 0 ? void 0 : (_fetchMoreResult$corp2 = _fetchMoreResult$corp.navigation_data) === null || _fetchMoreResult$corp2 === void 0 ? void 0 : (_fetchMoreResult$corp3 = _fetchMoreResult$corp2.navigation_data) === null || _fetchMoreResult$corp3 === void 0 ? void 0 : _fetchMoreResult$corp3.__typename) !== 'HRISCorporationsGetChildrenOrgNavigationQueryPayload') {
          return prev;
        }
        var prevPayload = (_prev$corporation = prev.corporation) === null || _prev$corporation === void 0 ? void 0 : (_prev$corporation$nav = _prev$corporation.navigation_data) === null || _prev$corporation$nav === void 0 ? void 0 : _prev$corporation$nav.navigation_data;
        var newPayload = (_fetchMoreResult$corp4 = fetchMoreResult.corporation) === null || _fetchMoreResult$corp4 === void 0 ? void 0 : (_fetchMoreResult$corp5 = _fetchMoreResult$corp4.navigation_data) === null || _fetchMoreResult$corp5 === void 0 ? void 0 : _fetchMoreResult$corp5.navigation_data;

        // Patch: If there's no previous payload in Apollo's cache structure,
        // fall back to using the current data from the hook
        var fallbackPayload = data === null || data === void 0 ? void 0 : (_data$corporation5 = data.corporation) === null || _data$corporation5 === void 0 ? void 0 : (_data$corporation5$na = _data$corporation5.navigation_data) === null || _data$corporation5$na === void 0 ? void 0 : _data$corporation5$na.navigation_data;
        var sourcePayload = prevPayload || fallbackPayload;
        if (!sourcePayload) {
          return fetchMoreResult;
        }
        if ((sourcePayload === null || sourcePayload === void 0 ? void 0 : sourcePayload.__typename) !== 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' || (newPayload === null || newPayload === void 0 ? void 0 : newPayload.__typename) !== 'HRISCorporationsGetChildrenOrgNavigationQueryPayload') {
          return prev;
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          corporation: _objectSpread(_objectSpread({}, prev.corporation), {}, {
            navigation_data: _objectSpread(_objectSpread({}, (_prev$corporation2 = prev.corporation) === null || _prev$corporation2 === void 0 ? void 0 : _prev$corporation2.navigation_data), {}, {
              navigation_data: _objectSpread(_objectSpread({}, newPayload), {}, {
                // Preserve critical metadata from the first successful fetch
                is_corporation: sourcePayload.is_corporation,
                is_current_parent_org: sourcePayload.is_current_parent_org,
                parent_org_id: sourcePayload.parent_org_id,
                current_org: sourcePayload.current_org,
                organizations: [].concat(_toConsumableArray(sourcePayload.organizations), _toConsumableArray(newPayload.organizations))
              })
            })
          })
        });
      }
    })["catch"](console.error)["finally"](function () {
      setFetchingMore(false);
    });
  };
  var handleRefetch = function handleRefetch() {
    refetch();
  };
  var currentOrganization = (result === null || result === void 0 ? void 0 : result.__typename) === 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' ? {
    id: result.current_org.id,
    name: result.current_org.name,
    slug: result.current_org.slug,
    homeUrl: HOME_URL.replace('[slug]', result.current_org.slug)
  } : null;
  var isCurrentParentOrg = (result === null || result === void 0 ? void 0 : result.__typename) === 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' ? result.is_current_parent_org : false;
  var parentOrganizationId = (result === null || result === void 0 ? void 0 : result.__typename) === 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' ? result.parent_org_id : null;
  var isCorporation = (result === null || result === void 0 ? void 0 : result.__typename) === 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' ? result.is_corporation : false;

  // Cache the corporation data once we have it
  if ((result === null || result === void 0 ? void 0 : result.__typename) === 'HRISCorporationsGetChildrenOrgNavigationQueryPayload' && !cachedCorporationData) {
    var _result$parent_org_id;
    setCachedCorporationData({
      isCorporation: result.is_corporation,
      isCurrentParentOrg: result.is_current_parent_org,
      parentOrganizationId: (_result$parent_org_id = result.parent_org_id) !== null && _result$parent_org_id !== void 0 ? _result$parent_org_id : null,
      isCorporationEmpty: !search && organizations.length === 0
    });
  }

  // Only return loading state on initial load, not during fetchMore or search operations
  // If we already have cached data, preserve those values to prevent UI flicker
  if (loading && !data) {
    var _cachedCorporationDat, _cachedCorporationDat2, _cachedCorporationDat3, _cachedCorporationDat4;
    return {
      loading: true,
      fetchingMore: false,
      error: false,
      organizations: null,
      isCorporation: (_cachedCorporationDat = cachedCorporationData === null || cachedCorporationData === void 0 ? void 0 : cachedCorporationData.isCorporation) !== null && _cachedCorporationDat !== void 0 ? _cachedCorporationDat : false,
      isCurrentParentOrg: (_cachedCorporationDat2 = cachedCorporationData === null || cachedCorporationData === void 0 ? void 0 : cachedCorporationData.isCurrentParentOrg) !== null && _cachedCorporationDat2 !== void 0 ? _cachedCorporationDat2 : null,
      parentOrganizationId: (_cachedCorporationDat3 = cachedCorporationData === null || cachedCorporationData === void 0 ? void 0 : cachedCorporationData.parentOrganizationId) !== null && _cachedCorporationDat3 !== void 0 ? _cachedCorporationDat3 : null,
      currentOrganization: null,
      refetch: handleRefetch,
      fetchMore: handleFetchMore,
      isCorporationEmpty: (_cachedCorporationDat4 = cachedCorporationData === null || cachedCorporationData === void 0 ? void 0 : cachedCorporationData.isCorporationEmpty) !== null && _cachedCorporationDat4 !== void 0 ? _cachedCorporationDat4 : false
    };
  }
  if (error || (result === null || result === void 0 ? void 0 : result.__typename) !== 'HRISCorporationsGetChildrenOrgNavigationQueryPayload') {
    return {
      loading: false,
      fetchingMore: false,
      error: true,
      organizations: null,
      isCorporation: false,
      isCurrentParentOrg: null,
      parentOrganizationId: null,
      currentOrganization: null,
      refetch: handleRefetch,
      fetchMore: handleFetchMore,
      isCorporationEmpty: false
    };
  }
  return {
    loading: false,
    // If Apollo loading is true and we have data, it means we're fetching more
    fetchingMore: fetchingMore || loading && !!data,
    error: false,
    hasMore: result === null || result === void 0 ? void 0 : result.has_next_page,
    count: result === null || result === void 0 ? void 0 : result.total_count,
    organizations: organizations,
    isCorporation: isCorporation,
    isCurrentParentOrg: isCurrentParentOrg,
    currentOrganization: currentOrganization,
    parentOrganizationId: parentOrganizationId,
    refetch: handleRefetch,
    fetchMore: handleFetchMore,
    isCorporationEmpty: !search && organizations.length === 0
  };
};